import { getDanhSachPhuPhiGV, getTaiKhoanGiaoVien, getThongTinLuong } from '@/services/TaiKhoanGiaoVien/taikhoangiaovien';
import { useState } from 'react';
import type { TaiKhoanGiaoVien } from '@/services/TaiKhoanGiaoVien';

export default () => {
  const [danhSach, setDanhSach] = useState<TaiKhoanGiaoVien.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [recordGV, setRecordGV] = useState<TaiKhoanGiaoVien.Record>();
  const [thang, setThang] = useState<number>(new Date().getMonth());
  const [nam, setNam] = useState<number>(new Date().getFullYear());
  const [dsPhuPhiGV,setDSPhuPhiGV] = useState([])
  const [idLT,setIdLuongTruong] = useState([]);

  const getTaiKhoanGiaoVienModel = async (organizationId?: string,thang?: number, nam?: number) => {
    setLoading(true);
    const idTruong = cond?.organizationId || organizationId;
    const response = await getTaiKhoanGiaoVien({ page, limit, cond, idTruong,thang,nam, filterInfo });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  };
  const getDanhSachPhuPhiGVModel =async (organizationId?: string,thang?: number, nam?: number)=>{
    setLoading(true);
    const idTruong = cond?.organizationId || organizationId;
    const res =await getDanhSachPhuPhiGV ({ page, limit, cond, idTruong,thang,nam})
    setDSPhuPhiGV(res?.data?.data?.danhSachPhuPhi ?? [] )
    setIdLuongTruong(res?.data?.data?._id)
    setLoading(false);
  }

  return {
    idLT,
    dsPhuPhiGV,
    getDanhSachPhuPhiGVModel,
    danhSach,
    recordGV,
    setRecordGV,
    loading,
    setLoading,
    getTaiKhoanGiaoVienModel,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
  };
};
